if (!customElements.get('mini-cart')) {  
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.cartModalOpen = false;
      this.upsellThreshold = null;
      this.upsellShown = false;
    }

    connectedCallback() {
      this.cartUrl = this.dataset.cartUrl;
      this.sectionId = this.dataset.sectionId;
      this.cart = JSON.parse(this.dataset.cartJson) || null;
      this.ubeStoreUrl = this.dataset.ubeStoreUrl;
      this.showNotifications = true;
  

      const thresh = this.dataset.upsellThreshold;
      if (thresh && thresh.toLowerCase() !== 'false') {
        const whole = parseInt(thresh, 10);
        this.upsellThreshold = Number.isFinite(whole) ? whole * 100 : null;
      }

      if (!this.isConnected) return;
      
      window.addEventListener('minicart:bulkadd', e => {
        this.bulkAddToCart(e.detail.items)
          .then(res => {
            if(!res) return;
            this.updateCartHtml(res).then(() => {
              this.checkUbeInventory();
            }).then(this.open());
          })
          .finally(() => {
            this.classList.remove('loading');
            window.dispatchEvent(new Event(`addToCartDidSubmit`));
          });
      })
      
      this.addDelegatedClickListeners();

      document.addEventListener('DOMContentLoaded', () => {
        this.classList.remove('loading');
        this.checkUbeInventory();
        this.getRecommendedProducts();
        this.saveProductSizes();
        this.setupFreeGifts();
        this.disableGiftButtonsIfLoopActive();
      });
      if (document.readyState === 'complete') this.classList.remove('loading');

      setInterval(() => this.disableGiftButtonsIfLoopActive(), 2000);

      window.addEventListener('pageshow', () => {
        setTimeout(() => this.refreshFromServer(), 100);
      });

      // Loop can't see the notification checkout button so we are proxy clicking the mini-cart one
      window.addEventListener('click', (e) => {
        if (!e.target.closest('[data-cart-action="proxy-checkout"]')) return;
        document.getElementById('cart-checkout-button')?.click();
      });
    }

    setupFreeGifts() {
      if (this.querySelector('[data-remove]')) {
        this.classList.add('loading');
        this.updateQty(this.querySelector('[data-remove]').value, 0)
          .then((res) => {
            if (!res) return;
            this.updateCartHtml(res).then(() => {
              this.checkUbeInventory();
              this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
            });
          }).finally(() => this.classList.remove('loading'));
        return;
      }

      if (this.querySelector('[data-add]') && !window.isLoopActive?.()) {
        this.addToCart(this.querySelector('[data-add]').value, false, false, { '_free_gift': this.querySelector('[data-add]').dataset.add, '_removal_not_allowed': 'true' }, 1)
          .then(res => {
            if(!res) return;
            this.updateCartHtml(res).then(() => {
              this.checkUbeInventory();
            }).then(this.open());
          })
          .finally(() => {
            this.classList.remove('loading');
            window.dispatchEvent(new Event(`addToCartDidSubmit`));
          });
          return;
      }
    }

    disableGiftButtonsIfLoopActive() {
      const loopActive = !!window.isLoopActive?.();
      this.querySelector('.progress-row')?.classList.toggle('hidden', loopActive);
      this.querySelectorAll('free-gift').forEach(el => el.classList.toggle('hidden', loopActive));
      this.querySelectorAll('[data-action="add-single-variant"], [data-quickbuy-id^="free-gift-quickbuy-"], [data-free-gift="true"] button[type="submit"]').forEach(btn => {
        btn.toggleAttribute('disabled', loopActive);
        btn.classList.toggle('opacity-50', loopActive);
        btn.classList.toggle('pointer-events-none', loopActive);
        btn.classList.toggle('cursor-not-allowed', loopActive);
      });
    }
    
    addDelegatedClickListeners() { 
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.cartModalOpen) { this.close(); return; }
        const modal = document.querySelector('drawer-modal');
        if (modal && !modal.classList.contains('!hidden')) {
          modal.close();
          if (this._notifTrigger) { this._notifTrigger.focus(); this._notifTrigger = null; }
        }
      });

      this.addEventListener('keydown', (e) => {
        if (!this.cartModalOpen || e.key !== 'Tab') return;
        const focusable = [...this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )].filter(el => el.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      window.addEventListener('click', (e) => {
        if (window.location.pathname === this.cartUrl || (e.target.closest('drawer-modal') && this.cartModalOpen) || e.target.closest('quickbuy-modal'))  return;
        
        if(e.target.closest(`[href="${this.cartUrl}"]`)) {
            e.preventDefault();
            this._cartTrigger = e.target.closest(`[href="${this.cartUrl}"]`);
            this.open();
            return;
        }
        if (e.target.closest('[data-close-cart]') && this.cartModalOpen) {
            this.close();
            return;
        }
        if (!e.target.closest('mini-cart') && this.cartModalOpen) {
            this.close();
            return;
        }
      });

      window.addEventListener('submit', (e) => {
        const productForm = e.target.closest('[action="/cart/add"]');
        if(!productForm) return;

        e.preventDefault();

        if (productForm.querySelector('[name="properties[_free_gift]"]') && window.isLoopActive?.()) return;

        let selling_plan = null;
        if (productForm.querySelector('[name="selling_plan"]') && productForm.querySelector('[name="selling_plan"]').value !== undefined) selling_plan = productForm.querySelector('[name="selling_plan"]').value;

        let discount = null;
        if (productForm.querySelector('[name="properties[Discount]"]') && productForm.querySelector('[name="properties[Discount]"]').value !== undefined) discount = productForm.querySelector('[name="properties[Discount]"]').value;

        const idToAdd = productForm.querySelector('select[name="id"]').value;
        const quantity = productForm.querySelector('select[name="quantity"]')?.value ?? 1;
        const propertyInputs = productForm.querySelectorAll('[data-form-property]');
        const recipientInputs = [...productForm.querySelectorAll(`[data-form-recipient]`)];
        const properties = {};

        if (propertyInputs) {
          for (let input of propertyInputs) {
            const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
            const val = input.value;

            properties[key] = val;
          }
        }
        
        if (recipientInputs.length > 0) {
          const controlFlag = recipientInputs.find((el) => el.getAttribute(`name`) === `properties[__shopify_send_gift_card_to_recipient]`);
          if (controlFlag.checked) {
            for (let input of recipientInputs) {
              const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
              const val = input.value;
  
              properties[key] = val;
            }
          }
        }

        this.classList.add('loading');

        const collectEvent = new CustomEvent('cart:collect-items', { detail: { items: [], invalid: false } });
        window.dispatchEvent(collectEvent);

        if (collectEvent.detail.invalid) {
          this.classList.remove('loading');
          return;
        }

        const extraItems = collectEvent.detail.items;

        const cartAdd = extraItems.length > 0
          ? this.bulkAddToCart([
              { id: idToAdd, qty: quantity, selling_plan, discount, properties },
              ...extraItems
            ])
          : this.addToCart(idToAdd, selling_plan, discount, properties, quantity);

        cartAdd
          .then(res => {
            if(!res) return;
            if(this.showNotifications && extraItems.length > 0) this.showNotification(res);
            this.updateCartHtml(res).then(() => {
              this.checkUbeInventory();
            }).then(() => {
              if (!this.showNotifications) this.open()
            });
          })
          .finally(() => {
            this.classList.remove('loading');
            window.dispatchEvent(new Event(`addToCartDidSubmit`));
            if (productForm.dataset.quickbuyForm == "true") {
              const quickModal = document.querySelector('quickbuy-modal');
              quickModal.close(true);
             // document.body.classList.add('overlay')
              this.removeAttribute('style');
              window.igEvents.push({"event": "Quickbuy Add to Cart"})
            };
          }
        );
      });

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-cart-action]');
        if (!clickedElement) return;

        const {
          cartAction: action,
          lineItemId,
          quantity,
          embroideryKey,
          digitizationKey,
          embroideryPair,
          baseItemKey,
          baseItemVariantId,
          baseItemQty,
          bundleId,
        } = clickedElement.dataset;

        switch (action) {
          case 'updateQty': {
            this.classList.add('loading');
            const desiredQuantity = Number(quantity);
            const bundleId = clickedElement.dataset.bundleId;
            const promises = [];
            if (embroideryKey) { promises.push(this.updateQty(embroideryKey, desiredQuantity)); }
            if (digitizationKey && desiredQuantity <= 1) { promises.push(this.updateQty(digitizationKey, desiredQuantity)); }
            if (embroideryPair) { promises.push(this.updateQty(embroideryPair, 0)); }
            if (baseItemKey) { promises.push(this.updateQty(baseItemKey, 0)); }
            const embroideryQuantity = Promise.all(promises);

            // When removing a bundle item, co-remove all sibling items with the same bundle_id
            const bundleSiblingKeys = desiredQuantity === 0 && bundleId
              ? [...this.querySelectorAll(`[data-bundle-id="${bundleId}"][data-line-key]`)]
                  .map(el => el.dataset.lineKey)
                  .filter(k => k && k !== lineItemId)
              : [];

            embroideryQuantity
              .then(() => {
                if (bundleSiblingKeys.length) {
                  const updates = { [lineItemId]: 0 };
                  bundleSiblingKeys.forEach(k => { updates[k] = 0; });
                  return this.bulkUpdateQty(updates);
                }
                return this.updateQty(lineItemId, Number(quantity));
              })
              .then((res) => {
                if (bundleId && desiredQuantity === 0) {
                  fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { [`Custom Logo Note: ${bundleId}`]: '' } })
                  });
                }
                if (!baseItemVariantId) return res;
                this.showNotifications = false;
                return this.addToCart(baseItemVariantId, null, null, {}, Number(baseItemQty))
                  .finally(() => { this.showNotifications = true; });
              })
              .then((res) => {
                if (!res) return;
                return this.updateCartHtml(res).then(() => {
                  this.checkUbeInventory();
                });
              })
              .then(() => {
                // Sync _discount on sibling bundle lines when qty changed (not removal)
                if (bundleId && desiredQuantity > 0 && !bundleSiblingKeys.length) {
                  return this.syncBundleDiscounts(bundleId);
                }
              })
              .finally(() => this.classList.remove('loading'));
            break;
          }
        }
      });
    }
    
    open() {
      if (document.querySelector('[data-hide-atc-desktop]')) {
        document.querySelector('[data-hide-atc-desktop]').style.display = "none";
      }
      this.click();
      this.cartModalOpen = true;
      this.classList.remove('translate-x-full');
      this.removeAttribute('inert');
      this.setAttribute('aria-hidden', 'false');
      if (!window.location.href.includes('/cart')) document.body.classList.add('overlay');
      setTimeout(() => this.querySelector('[data-close-cart]')?.focus(), 50);
      this.removeOrphanedEmbroideryItems();
    }

    async removeOrphanedEmbroideryItems() {
      try {
        const cart = await fetch(`/cart.js`, { credentials: `same-origin` }).then(r => r.json());
        const parentBundleIds = new Set(
          cart.items
            .filter(item => item.properties?.[`_embroidery_bundle_component`] === `parent`)
            .map(item => item.properties[`_embroidery_bundle_id`])
        );
        const orphanedKeys = cart.items
          .filter(item => {
            const bundleId = item.properties?.[`_embroidery_bundle_id`];
            const component = item.properties?.[`_embroidery_bundle_component`];
            return bundleId && component && component !== `parent` && !parentBundleIds.has(bundleId);
          })
          .map(item => item.key);
        if (!orphanedKeys.length) return;
        const updates = {};
        orphanedKeys.forEach(key => { updates[key] = 0; });
        const res = await fetch(`/cart/update.js`, {
          method: `POST`,
          credentials: `same-origin`,
          headers: { 'Content-Type': `application/json` },
          body: JSON.stringify({ updates, sections: [this.sectionId] }),
        }).then(r => r.json());
        await this.updateCartHtml(res);
      } catch (err) {
        console.error(`Failed to remove orphaned embroidery items`, err);
      }
    }

    close() {
      if (document.querySelector('[data-hide-atc-desktop]')) {
        document.querySelector('[data-hide-atc-desktop]').style.display = null;
      }
      this.cartModalOpen = false;
      this.classList.add('translate-x-full');
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overlay');
      if (this._cartTrigger) {
        this._cartTrigger.focus();
        this._cartTrigger = null;
      }
    }

    async addToCart(id, selling_plan = null, _discount = null, properties, qty) {
      const data = {
        id,
        quantity: qty,
        sections: [this.sectionId]
      };

      if (properties && Object.keys(properties).length !== 0) {
        data.properties = properties;
      }

      if (selling_plan) data.selling_plan = selling_plan;

      try {
        const response = await fetch('/cart/add.js', {
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          method: 'POST'
        });

        const json = await response.json();

        if (!response.ok) {
          console.error(`add to cart failed: ${response.status} ${response.statusText}`, json?.message || json);
          let message = json?.message || json;
          if (message.includes(`due to availability`) || message.includes(`The maximum quantity of this item is already in your cart`)) {
            message = `Sorry, the maximum quantity of this item is already in your cart. Please select a different size or product.`;
          }
          alert(message);
          return null;
        }

        if(this.showNotifications) this.showNotification(json);

        // tracking would go here
        return json;
      } catch (err) {
        console.error('add to cart err', err);
        return null;
      }
    }
    
    async bulkAddToCart(items) {
      const payloadItems = items.map(({ id, qty = 1, selling_plan = null, properties = {} }) => {
        const props = { ...properties };

        const item = {
          id,
          quantity: qty
        };

        if (Object.keys(props).length) item.properties = props;
        if (selling_plan) item.selling_plan = selling_plan;

        return item;
      });

      const data = {
        items: payloadItems,
        sections: [`${this.sectionId}`]
      };

      const cartContents = fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        },
        method: 'POST'
      })
        .then((response) => response.json())
        .finally((res) => {
          // tracking would go here
        })
        .catch(function(err) {
          console.error(err);
        });

      return cartContents;
    }

    async refreshFromServer() {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: {}, sections: [`${this.sectionId}`] }),
      })
        .then(r => r.json())
        .catch(err => console.error('Error refreshing cart:', err));
      if (res) this.updateCartHtml(res);
    }

    async updateCartHtml(res) {
      let newHtml = res?.sections?.[`${this.sectionId}`];
      const quickbuy = document.querySelector('quickbuy-modal');
      if (!newHtml) {
        alert('Something went wrong.');
        return;
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtml;
      
      if (tempDiv.querySelector('[data-remove]')) {
        this.classList.add('loading');
        this.updateQty(tempDiv.querySelector('[data-remove]').value, 0)
          .then((res) => {
            if (!res) return;
            this.updateCartHtml(res).then(() => {
              this.checkUbeInventory();                
              this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
            });
          }).finally(() => this.classList.remove('loading'));
        return;
      }
      
      if (tempDiv.querySelector('[data-add]') && !window.isLoopActive?.()) {
        this.addToCart(tempDiv.querySelector('[data-add]').value, false, false, { '_free_gift': tempDiv.querySelector('[data-add]').dataset.add, '_removal_not_allowed': 'true' }, 1)
          .then(res => {
            if(!res) return;
            this.updateCartHtml(res).then(() => {
              this.checkUbeInventory();
            }).then(this.open());
          })
          .finally(() => {
            this.classList.remove('loading');
            window.dispatchEvent(new Event(`addToCartDidSubmit`));
          });
          return;
      }

      this.innerHTML = tempDiv.querySelector('mini-cart').innerHTML;
      this.disableGiftButtonsIfLoopActive();
      const count = Number(tempDiv.querySelector('mini-cart').dataset.cartItemCount) || '';
      this.cart = JSON.parse(tempDiv.querySelector('mini-cart').dataset.cartJson) || null;
      [...document.querySelectorAll('[data-cart-count]')].forEach(cartCount => {
        cartCount.innerHTML = count > 0 ? count : '';
      });
      this.getRecommendedProducts();  
      this.saveProductSizes();  
      const activeTemplate = document.querySelector('[data-drawer-content][data-quickbuy-type]');
      const quickbuyType = activeTemplate?.dataset.quickbuyType;
      if (quickbuyType === 'quickbuy') quickbuy?.close(true);
      this.showUpsell();
    }
    
    async updateQty(id, qty) {
      const updates = {};
      updates[id] = qty;

      const data = {
        updates,
        sections: [`${this.sectionId}`],
      };

      const cartContents = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });

      return cartContents;
    };

    async bulkUpdateQty(updates) {
      const data = {
        updates,
        sections: [`${this.sectionId}`],
      };
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then(r => r.json())
        .catch(err => console.error('Error:', err));
    }

    async syncBundleDiscounts(bundleId) {
      let cart;
      try {
        cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      } catch { return; }

      const bundleItems = (cart?.items || []).filter(item =>
        item.properties?.['_bundle_id'] === bundleId
      );
      if (!bundleItems.length) return;

      const psdRaw = bundleItems.find(i => i.properties?.['_pack_size_discounts'])?.properties?.['_pack_size_discounts'];
      if (!psdRaw) return;

      let psd;
      try { psd = JSON.parse(psdRaw); } catch { return; }

      const totalQty = bundleItems.reduce((s, i) => s + i.quantity, 0);

      // Greedy: find the largest pack size that fits within totalQty
      const sortedSizes = Object.keys(psd).map(Number).filter(n => n > 0).sort((a, b) => b - a);
      let newDiscountPct = 0;
      for (const size of sortedSizes) {
        if (totalQty >= size) { newDiscountPct = Number(psd[String(size)] || 0); break; }
      }

      const toUpdate = bundleItems.filter(item =>
        String(item.properties?.['_discount'] || '0') !== String(newDiscountPct)
      );
      if (!toUpdate.length) return;

      await Promise.all(toUpdate.map(item =>
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: { ...item.properties, _discount: String(newDiscountPct) },
          }),
        })
      ));

      // Re-render cart after property update
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: {}, sections: [this.sectionId] }),
      }).then(r => r.json());

      await this.updateCartHtml(res);
    }

    checkUbeInventory() {
      const requestToken = this.querySelector('[data-ube-hash]')?.value;
      if (!requestToken) return;
      const gcHash = btoa(String.fromCharCode.apply(null, requestToken.match(/\w{2}/g).map((a) => parseInt(a, 16))));
      const cart_data = {};
      const ubeCartItems = this.querySelectorAll('[data-ube-item]');
      const params = new URLSearchParams();

      // Example shape of data if it's returned with an error
      // leaving here for reference
      // {
      //   "custom-div-1": "0|<span style='color:red;'>Oh no! This item is now out of stock, but don't worry you can sign up to be notified when it comes back in by going to the <a href=\"/products/Aero-Mens-Knit-Panel-Cargo-Scrub-Pant-Hunter?variant=43645018538214\">product page </a> and opting in. Head back to this page and remove this item from your cart to continue checkout.</span>",
      //   "custom-div-2": "2 pcs - To Ship By  03-03-2023"
      // } 
           
      ubeCartItems.forEach(({ dataset: { style, color, size, productId, uid, qty }}, i) => {
        const index1 = i + 1;
        cart_data[`cart_item_${index1}`] = {};
        cart_data[`cart_item_${index1}`]['item_id'] = uid;
        cart_data[`cart_item_${index1}`]['item_color'] = color;
        cart_data[`cart_item_${index1}`]['item_style'] = style;
        cart_data[`cart_item_${index1}`]['item_size'] = size;
        cart_data[`cart_item_${index1}`]['product_id'] = productId;
        cart_data[`cart_item_${index1}`]['item_qty'] = qty;
      });
      
      for (const [key, value] of Object.entries(cart_data)) {
        for (const [subkey, subvalue] of Object.entries(value)) {
          params.append(`cart_data[${key}][${subkey}]`, subvalue);
        }
      }
      params.append('token', gcHash)
      
      fetch(`${this.ubeStoreUrl}/main-cart-api.php`, {
        method: 'POST',
        headers: {
          accept: 'application/json, text/javascript, */*'
        },
        body: params,
      })
        .then((response) => response.json())
        .then(data => {
          this.querySelectorAll('[data-ube-wrapper]').forEach(el => {
            const variantId = el.dataset.variantId;
            const itemKey = el.dataset.itemKey; 
            const ubeWrapper = el.dataset.ubeWrapper;
            if (!data[ubeWrapper]) return;
            
            if (data[ubeWrapper].toLowerCase().trim().includes('oh no')) {
              el.innerHTML = `Oops! Out of stock in your quantity. (<button data-drawer-id="notify-me-${itemKey}" data-drawer-action="open" data-variant-id="${variantId}" class="button-link text-xs text-primaryDark">Notify me when back in stock.</button>)`;
              return;
            }
            
            el.innerHTML = data[ubeWrapper];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }

    saveProductSizes() {
      if (!this.cart?.items.length) return;
      let itemTypes = {};

      for (let i = 0; i < this.cart.items.length; i++) {
        const item = this.cart.items[i];
        if (!itemTypes.hasOwnProperty(item.product_type)) {
          itemTypes[item.product_type] = item.variant_title;
        }
      }
      
      localStorage.setItem(`cartSizes`, JSON.stringify(itemTypes));
    }

    getRecommendedProducts() {
      if (!this.cart?.items.length) return;
      const recommendationsWrapper = this.querySelector('[data-recommended-products]');
      if (!recommendationsWrapper) return;
      
      const reccsToRenderPerCartItem = Math.round(5/this.cart.items.length);
      const isCartPage = recommendationsWrapper.dataset.cartPage;
      let desktopSlidesPerView = '1.2';
      let desktopLargeSlidesPerView = '1.2';
      if (isCartPage === 'true') {
        desktopSlidesPerView = '1.8';
        desktopLargeSlidesPerView = '2.5'
      }
      recommendationsWrapper.innerHTML = '';
      
      for (let i = 0; i < this.cart.items.length; i++) {
        const item = this.cart.items[i];
        fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${item.product_id}`)
          .then(response => {
            return response.json()
          })
          .then(({ products }) => {
            const filteredReccs = products
              .filter(({ id, tags }) => {
                return !this.cart.items.find(({ product_id }) => id == product_id) 
                && !tags.some(tag => tag === 'base_product')
              })
              .slice(0, reccsToRenderPerCartItem)
            
              recommendationsWrapper.innerHTML = `
                <swiper-carousel
                  data-space-between="8"
                  data-slides-per-view-mobile="1"
                  data-slides-per-view-medium="1.2"
                  data-slides-per-view="${desktopSlidesPerView}"
                  data-slides-per-view-large="${desktopLargeSlidesPerView}"
                >
                  <div class="pb-2 flex align-center justify-between">
                    <strong class="text-xs text-primaryDark font-semibold">You May Also Like</strong>
                  </div>
                  <div class="swiper-wrapper min-h-[110px]">
                    ${filteredReccs.map((recc) => `
                      <div class="swiper-slide">
                        <intersection-loader 
                          data-url="/products/${recc.handle}" 
                          data-section-id="cart-upsell"
                        >
                          <div class="!flex !w-full !opacity-100 loader">
                            <span class="block w-12 h-12">
                              <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                            </span>
                          </div>
                        </intersection-loader>
                      </div>
                    `).join('')}
                  </div>
                </swiper-carousel>
              `;
          })
      }
    }
    
    openDrawerById(id) {
      const template = document.querySelector(`[data-drawer-content="${id}"]`);
      const quickbuy = document.querySelector('quickbuy-modal');
      if (!template || !quickbuy) return;
      quickbuy.classList.remove('left', 'right', 'bottom', 'center-bottom');
      const direction = template.dataset.direction || 'left';
      quickbuy.classList.add(direction);
      const content = template.content.cloneNode(true);
      quickbuy.innerHTML = '';
      quickbuy.appendChild(content);
      quickbuy.classList.remove('!hidden');
      document.body.classList.add('overlay');
      setTimeout(() => {
        quickbuy.classList.remove(
          '-translate-x-full',
          'md:translate-x-full',
          '[&.center]:translate-x-0',
          '[&.center]:translate-y-full'
        );
      }, 10);
      quickbuy.setAttribute('open', 'true');
      quickbuy.dispatchEvent(new CustomEvent('drawer:opened', { detail: { id, direction } }));
    }

    showUpsell() {
      if (!this.upsellThreshold || !this.cart) return;
      const alreadyShown = sessionStorage.getItem('upsellModalShown') === 'true';
      if (alreadyShown) return;
      const total = Number(this.cart.cart_total) || 0;
      const above = total >= this.upsellThreshold;
      if (above && !this.upsellShown) {
        setTimeout(() => {
          this.style.zIndex = 20;
          setTimeout(() => {
            this.upsellShown = true;
            sessionStorage.setItem('upsellModalShown', 'true');
            this.openDrawerById('upsell-modal');
          }, 300);
        }, 500);
      }
  
      if (!above) this.upsellShown = false;
    }

    async showNotification(json) {
      this._notifTrigger = document.activeElement;
      const modal = document.querySelector('drawer-modal');
      modal.innerHTML = '';
      const template = this.querySelector('[data-drawer-content="cart-notification"]');
      if (!template) return;

      if (this.notificationCloseTimeout) clearTimeout(this.notificationCloseTimeout);

      const content = template.content.cloneNode(true);
      const item_target = content.querySelector('[data-notification-content]');

      if (item_target) {
        const items = (json.items || [json]).filter(item => item?.title);

        // Enrich items with compare_at_price — not returned by /cart/add.js,
        // so we fetch it from the product JSON endpoint per unique handle.
        const productCache = {};
        const enrichedItems = await Promise.all(
          items.map(async (item) => {
            try {
              if (!productCache[item.handle]) {
                productCache[item.handle] = fetch(`/products/${item.handle}.js`).then(r => r.json());
              }
              const product = await productCache[item.handle];
              const variant = product.variants?.find(v => v.id === item.variant_id);
              return { ...item, compare_at_price: variant?.compare_at_price ?? null };
            } catch {
              return item;
            }
          })
        );

        item_target.innerHTML = enrichedItems.map(item => {
          const fmt = cents => '$' + ((cents || 0) / 100).toFixed(2).replace(/\.00$/, '');
          // final_price reflects any applied discount codes; price is the pre-discount variant price
          const displayPrice = item.final_price ?? item.price;
          // Prefer compare_at_price as the strikethrough (variant-level sale);
          // fall back to item.price if a discount code brought final_price below it
          const strikethroughPrice = (item.compare_at_price && item.compare_at_price > item.price)
            ? item.compare_at_price
            : (displayPrice < item.price ? item.price : null);

          return `
          <div class="flex gap-6">
            <div>
              <img src="${item.featured_image?.url ? item.featured_image.url + '&width=150' : ''}" alt="${item.title || ''}" width="200" loading="lazy" class="object-cover max-w-[66px] max-h-[94px] aspect-[66/84] mix-blend-multiply">
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase">${(item.title || '').split(' - ')[0]}</span>
              <ul class="flex [&_*]:text-xxs text-primaryDarkScale-600 [&>li+li]:before:content-['•'] [&>li+li]:before:px-2 [&>li+li]:before:inline-block">
                ${[...(item.options_with_values || []).map(opt => `${opt.value}`),
                    (item.product_title || '').split(' - ').slice(-1)[0]
                  ].map(v => `<li>${v}</li>`).join('')}
              </ul>
              ${strikethroughPrice
                ? `<div class="flex items-center gap-1">
                    <span class="text-xs font-medium text-crimsonRed">${fmt(displayPrice)}</span>
                    <s class="text-xs font-normal text-primaryDarkScale-700">${fmt(strikethroughPrice)}</s>
                  </div>`
                : `<span class="text-xs">${fmt(displayPrice)}</span>`
              }
            </div>
          </div>
        `}).join('');
      }

      modal.replaceChildren(content);
      modal.classList.remove('!hidden');
      modal.classList.add('top-right', 'transition-all', 'duration-500');

      setTimeout(() => {
        document.body.classList.add('overlay');
        modal.classList.remove(
          '-translate-x-full',
          'md:translate-x-full',
          '[&.right]:translate-x-full',
          '[&.top-right]:translate-x-full',
          '[&.bottom]:translate-x-0',
          '[&.bottom]:translate-y-full',
          '[&.center-bottom]:translate-x-0',
          '[&.center-bottom]:translate-y-full'
        );
        modal.querySelector('[data-drawer-action="close"]')?.focus();
      }, 10);

      this.notificationCloseTimeout = setTimeout(() => {
        if (!this.cartModalOpen) {
          modal.classList.add(
            '-translate-x-full',
            'md:translate-x-full',
            '[&.right]:translate-x-full',
            '[&.top-right]:translate-x-full',
            '[&.bottom]:translate-x-0',
            '[&.bottom]:translate-y-full',
            '[&.center-bottom]:translate-x-0',
            '[&.center-bottom]:translate-y-full'
          );
          document.body.classList.remove('overlay');
        }
      }, 5000);
      
    }

  }

  customElements.define('mini-cart', MiniCart);
}


if (!customElements.get('cart-purchase-progress')) {
  customElements.define(
    'cart-purchase-progress',
    class CartPurchaseProgress extends HTMLElement {
      constructor() {
        super();
        this.maxThreshhold = 0;
        this.freeShippingThreshhold = null;
        this.messagingEl = this.closest('[data-progress-wrapper]')?.querySelector('[data-threshhold-messaging]');
        this.preMessagingEl = this.closest('[data-progress-wrapper]')?.querySelector('[data-threshhold-pre-messaging]');
        this.progressType = this.dataset.progressBarType;
      }
    
      connectedCallback() {        
        this.init();
        
        window.addEventListener('cart:update', e => {
          let total_price = e.detail.total_price;

          e.detail.items.forEach(item => {
            if (item.product_type.toLowerCase().includes(`gift card`)) total_price = total_price - item.line_price;
          });

          this.updateSelf(total_price, e.detail.item_count);
          window.dispatchEvent(new CustomEvent('cart:dataChange', { 
            detail: e.detail
          }));
        });
        
        window.addEventListener('productForm:add', e => {
          this.fetchAndUpdate();          
        });
      }
      
      init () {
        if (!window.cartProgressBarVariables) {
          console.error('Minicart:CartPurchaseProgress: Unable to get settings variables. Progress bar not initiated.')
          this.closest('[data-progress-wrapper]')?.remove();
          return;
        }
                
        window.cartProgressBarVariables.forEach((tier) => {
          if ((tier.purchase_threshhold * 100) > this.maxThreshhold) this.maxThreshhold = (tier.purchase_threshhold * 100);
          const pre_threshhold_message = tier.pre_threshhold_message?.toLowerCase() ?? '';
          const post_threshhold_message = tier.post_threshhold_message?.toLowerCase() ?? '';
          if (pre_threshhold_message.includes('free shipping') || post_threshhold_message.includes('free shipping')) {
            this.freeShippingThreshhold = tier.purchase_threshhold * 100;
          }
        });
        
        this.fetchAndUpdate();          
        this.generateMarkers();
      }
      
      fetchAndUpdate = () => {
        fetch('/cart.json')
          .then(res => res.json())
          .then(res => {
            window.dispatchEvent(new CustomEvent('cart:dataChange', { 
              detail: res
            }));
            window.cartTotalPrice = res.total_price;
            window.cart = res;

            let total_price = res.total_price;

            res.items.forEach(item => {
              if (item.product_type.toLowerCase().includes(`gift card`)) total_price = total_price - item.line_price;
            });
            
            this.updateSelf(total_price, res.item_count);
          })

        showProp65Messages();
      }
      
      generateMarkers() {
        const iconInactive = document.querySelector('template[data-icon="progress-bar-inactive"]')?.innerHTML;
        const iconActive = document.querySelector('template[data-icon="progress-bar-active"]')?.innerHTML;

        if (this.progressType === 'tier') {
          this.classList.add('tiered');
          const sortedItems = [...window.cartProgressBarVariables]
            .filter((item, index, arr) => arr.findIndex(obj => obj.purchase_threshhold === item.purchase_threshhold) === index)
            .sort((a, b) => a.purchase_threshhold - b.purchase_threshhold);
          this.insertAdjacentHTML(`beforeEnd`, sortedItems.map(item => `
            <div
              data-threshhold="${item.purchase_threshhold * 100}"
              class="
                w-full 
                text-center
                flex
                flex-col
                h-full
                relative
                justify-center
                [&_.icon-active]:hidden 
                [&.active_.icon-inactive]:hidden 
                [&.active_.icon-active]:block 
                [&_.icon]:bg-white
                [&_.icon]:border-2
                [&_.icon]:border-primaryBrand
                [&_.icon]:relative
                [&_.icon]:z-[1]
                z-0
                [&.active]:z-[1]
                [&.active_.icon]:bg-primaryDark
                [&.active_.icon]:border-primaryDark
                [&_.progress]:-relative
                [&_.progress]:w-[calc(100%+32px)]
                [&_.progress]:flex-grow
                [&_.progress]:h-2
                [&_.progress]:-mx-4
                [&_.progress]:bg-primaryBrand
                [&.active_.progress]:bg-primaryDark
                [&.active_.progress:last-of-type]:rounded-r-3xl
                [&.active:last-of-type_.progress:last-of-type]:z-1
                [&:first-of-type_.progress:first-of-type]:rounded-l-3xl
                [&:first-of-type_.progress:first-of-type]:ml-0 
                [&:first-of-type_.progress:first-of-type]:-mr-8
                [&:last-of-type_.progress:last-of-type]:rounded-r-3xl
                [&:last-of-type_.progress:last-of-type]:mr-0
                [&:last-of-type_.progress:last-of-type]:-ml-8

                ${window.cartTotalPrice >= (item.purchase_threshhold * 100) ? 'active' : ''}
              "
            >
              <span class="mb-1 message !font-normal">$${item.purchase_threshhold.toFixed(2)}</span>
              <div class="flex items-center justify-center w-full mb-2">
                <span class="progress"></span>
                <span class="transition duration-200 rounded-full flex items-center justify-center min-w-6 w-6 h-6 icon -mx-1">
                  ${iconActive ? `
                      <div class="icon-active w-3 h-3 min-w-3">
                        ${iconActive}
                      </div>
                    ` : 
                    `
                      <svg class="icon-active" xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
                        <g clip-path="url(#clip0_23_554)">
                          <path d="M9.67377 1.21973L3.25115 7.13723L1.32506 5.36424" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_23_554">
                            <rect width="11" height="8" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    `
                  }
                  ${iconInactive ? `
                      <div class="icon-inactive w-3 h-3 min-w-3">
                        ${iconInactive}
                      </div>
                    ` : 
                    `
                      <svg class="icon-inactive" xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                        <g clip-path="url(#clip0_23_558)">
                          <path d="M1.246 3.85501H6.466C6.66385 3.85501 6.8536 3.93361 6.9935 4.07351C7.1334 4.21341 7.212 4.40316 7.212 4.60101V7.21101C7.212 7.40886 7.1334 7.59861 6.9935 7.73851C6.8536 7.87841 6.66385 7.95701 6.466 7.95701H1.246C1.04815 7.95701 0.8584 7.87841 0.718498 7.73851C0.578596 7.59861 0.5 7.40886 0.5 7.21101V4.60101C0.5 4.40316 0.578596 4.21341 0.718498 4.07351C0.8584 3.93361 1.04815 3.85501 1.246 3.85501Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M1.991 3.855V2.364C1.991 2.11922 2.03921 1.87683 2.13289 1.65068C2.22656 1.42453 2.36386 1.21904 2.53695 1.04595C2.71004 0.872865 2.91552 0.735563 3.14167 0.641889C3.36783 0.548214 3.61021 0.5 3.855 0.5C4.09978 0.5 4.34217 0.548214 4.56832 0.641889C4.79447 0.735563 4.99996 0.872865 5.17304 1.04595C5.34613 1.21904 5.48343 1.42453 5.57711 1.65068C5.67078 1.87683 5.719 2.11922 5.719 2.364V3.855" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_23_558">
                          <rect width="7.711" height="8.457" fill="white"/>
                        </clipPath>
                        </defs>
                      </svg>
                    `
                  }
                </span>
                <span class="progress"></span>
              </div>
              <span class="message">${item.post_threshhold_message}</span>
            </div>    
          `).join(''));  
          return;
        }
        
        const gifts = [...window.cartProgressBarVariables]
          .filter((item, index, arr) => arr.findIndex(obj => obj.purchase_threshhold === item.purchase_threshhold) === index);
          
        this.innerHTML = `
          <div 
            class="
              progress-bar
              transition-all
              duration-200 
              ease-[cubic-bezier(0.77,0.28,0.3,1.3)] 
              h-full 
              w-[var(--progress-percentage)] 
              after:w-full 
              after:h-full 
              after:block 
              rounded-3xl 
              after:rounded-3xl 
              after:bg-primaryDark
            "
          ></div>
        `;
        gifts.forEach((tier) => {
          const threshold = tier.purchase_threshhold * 100;
          const position = ((tier.purchase_threshhold * 100) / (this.maxThreshhold + 20)) * 100;
          const message = tier.post_threshhold_message;
      
          // Insert marker HTML
          this.insertAdjacentHTML(
            `beforeEnd`,
            `
              <span 
                data-threshhold="${threshold}"
                style="left: ${position}%;" 
                class="
                  ${window.cartTotalPrice >= threshold ? 'active' : ''}
                  [&_.icon-active]:hidden 
                  [&.active_.icon-inactive]:hidden 
                  [&.active_.icon-active]:block 
                  transition bg-primaryLight 
                  duration-200 
                  absolute 
                  top-1/2 
                  border-2 
                  [&.active_span]:bg-primaryDark 
                  [&.active]:border-primaryDark 
                  border-primaryBrand 
                  w-6 
                  h-6 
                  rounded-full 
                  block 
                  z-10 
                  transform 
                  -translate-y-1/2 
                  -translate-x-1/2   
                  [&.max-value]:-translate-x-[200%]     
                  ${this.maxThreshhold === threshold ? 'max-value' : ''}        
                "
              >
                <div
                  class="
                    absolute
                    top-0
                    h-max
                    w-max
                    left-1/2
                    transform
                    -translate-x-1/2
                    -translate-y-[calc(100%+4px)]
                    text-xs
                    tracking-[-0.22px]
                    message
                  "
                >
                  $${(threshold / 100).toFixed(2)}
                </div>
                
                <div
                  class="
                    absolute
                    bottom-0
                    h-max
                    w-max
                    left-1/2
                    transform
                    -translate-x-1/2
                    translate-y-[calc(100%+4px)]
                    message
                  "
                >
                  ${message}
                </div>
                
                <span class="transition duration-200 bg-primaryLight w-full h-full rounded-full flex items-center justify-center">
                  <svg class="icon-active" xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
                    <g clip-path="url(#clip0_23_554)">
                      <path d="M9.67377 1.21973L3.25115 7.13723L1.32506 5.36424" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_23_554">
                        <rect width="11" height="8" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="icon-inactive" xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                    <g clip-path="url(#clip0_23_558)">
                      <path d="M1.246 3.85501H6.466C6.66385 3.85501 6.8536 3.93361 6.9935 4.07351C7.1334 4.21341 7.212 4.40316 7.212 4.60101V7.21101C7.212 7.40886 7.1334 7.59861 6.9935 7.73851C6.8536 7.87841 6.66385 7.95701 6.466 7.95701H1.246C1.04815 7.95701 0.8584 7.87841 0.718498 7.73851C0.578596 7.59861 0.5 7.40886 0.5 7.21101V4.60101C0.5 4.40316 0.578596 4.21341 0.718498 4.07351C0.8584 3.93361 1.04815 3.85501 1.246 3.85501Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M1.991 3.855V2.364C1.991 2.11922 2.03921 1.87683 2.13289 1.65068C2.22656 1.42453 2.36386 1.21904 2.53695 1.04595C2.71004 0.872865 2.91552 0.735563 3.14167 0.641889C3.36783 0.548214 3.61021 0.5 3.855 0.5C4.09978 0.5 4.34217 0.548214 4.56832 0.641889C4.79447 0.735563 4.99996 0.872865 5.17304 1.04595C5.34613 1.21904 5.48343 1.42453 5.57711 1.65068C5.67078 1.87683 5.719 2.11922 5.719 2.364V3.855" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_23_558">
                      <rect width="7.711" height="8.457" fill="white"/>
                    </clipPath>
                    </defs>
                  </svg>
                </span>
              </span>
            `
          );
        });
      }
      
      updateSelf(cartTotalPrice, itemCount) {
        document.querySelectorAll('[data-cart-count]').forEach(x => x.innerText = itemCount > 0 ? itemCount : '');
        const progressPercentage = Math.min((cartTotalPrice / this.maxThreshhold) * 100, 100);
        document.body.style.setProperty("--progress-percentage", `${progressPercentage}%`);
        
        let minimumActiveValue = this.maxThreshhold;
        
        [...this.querySelectorAll(`[data-threshhold]`)].forEach(marker => {
          const threshhold = Number(marker.dataset.threshhold);
          if (threshhold <= minimumActiveValue && threshhold > cartTotalPrice) {
            minimumActiveValue = threshhold;
          }
          
          if (threshhold <= cartTotalPrice) {
            marker.classList.add('active');
          } else {
            marker.classList.remove('active');
          }
        });
                
        const activeThreshhold = window.cartProgressBarVariables.find(x => (x.purchase_threshhold * 100) === minimumActiveValue);
        const difference = ((minimumActiveValue - cartTotalPrice) / 100).toFixed(2);
      
        if (cartTotalPrice >= this.maxThreshhold) {
          this.messagingEl.innerHTML = '';
        } else {
          this.messagingEl.innerHTML = activeThreshhold ? activeThreshhold.pre_threshhold_message.replace('_difference_', `$${difference}`) : '';
        }
      }
    }
  )
}